export const environment = {
  production: true,

  SOCKET_SERVICE: 'ws://3.225.94.224:4343/',
//  SERVICE_NAME: 'http://3.225.94.224:5050/api/'
   SERVICE_NAME: 'https://schedulerhub.shop/api/'
  // SERVICE_NAME: 'http://localhost:5050/api/'

  // SOCKET_SERVICE: 'ws://0.0.0.0:6379/',
  // SERVICE_NAME: 'http://localhost:6262/api/'
  // SERVICE_NAME: 'https://78c4-103-58-65-242.in.ngrok.io/api/'

};
